type HeaderProps = {
  title: string;
  time: string;
  currentSectionName: string;
  shouldShowTimer: boolean;
  closeFunction: () => void;
  hideExitBtn?: boolean;
};
import { Timer as TimerIcon, X } from 'lucide-react';

import LogoAndText2 from '../../../../assets/svg/LogoAndText2.svg';
import Timer from '../../../ReUsableComponents/Timer';
const TestHeader = ({
  title,
  time,
  currentSectionName,
  shouldShowTimer,
  closeFunction,
  hideExitBtn
}: HeaderProps) => (
  <div
    style={{ width: '100%' }}
    className='flex place-content-center items-center bg-white p-2 px-3 md:h-[78px] md:p-4 md:px-10'
  >
    <div
      className={`${!shouldShowTimer ? 'md:w-[45%]' : 'justify-items-center md:w-[100%]'} w-[40%]`}
    >
      <h1 className='flex flex-col items-start justify-center text-sm font-medium md:text-lg'>
        {/* <p className='max-w-[200px] truncate md:max-w-none'>{title}</p> */}
        <img src={LogoAndText2} alt='logo' className='h-6 md:h-8' />
      </h1>
    </div>

    {!shouldShowTimer && (
      <div className='flex w-[20%] flex-col items-center text-center text-primary md:w-[10%]'>
        <TimerIcon />
        <Timer />
      </div>
    )}

    {!shouldShowTimer && (
      <div className='flex w-[40%] justify-end text-sm md:w-[45%] md:text-base'>
        {!hideExitBtn && (
          <button
            className='flex max-w-[150px] truncate text-blue_a12 md:max-w-none'
            onClick={() => closeFunction()}
          >
            <X /> Close
          </button>
        )}
      </div>
    )}
  </div>
);

export default TestHeader;
